// Spacing prop names
const marginPropList = ['marginTop', 'marginBottom', 'marginLeft', 'marginRight', 'marginX', 'marginY'];
const paddingPropList = ['paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingX', 'paddingY'];

// Multiplier
// TODO: extract multiplier to scss value => vuex.store
const maxSpacingMultiplier = 10;
const properSpacingAmount = (spacingValue) => !spacingValue || Number(spacingValue) <= maxSpacingMultiplier;
const createSpacingProps = (spacingProps) => spacingProps.reduce(
    (acc, prop) => (
        { 
            ...acc, 
            [prop]: {
                type: [Number, String],
                default: '',
                validator: properSpacingAmount
            }
        }
    ), {}
);

export default {
    props: {
        ...createSpacingProps([...marginPropList, ...paddingPropList])
    }
}
